import React from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  avatar__container,
  avatar__img,
  chat__container,
  chat__video__bubble,
  chat__video__container,
  chat__video__footer__container,
  chat__video__footer__time,
  chat__video__img__box,
  chat__video__wrapper,
  img,
  img__container,
  play__icon,
} from "./style";

export default function VideoMessage({
  align = "LEFT",
  avatarImageUrl = "",
  media = {},
  time = "",
  showAvatarImage = false,
  isRead = false,
  sending = false,
  failed = false,
  onClick = () => {},
}) {
  align = align
    ? ["LEFT", "RIGHT"].includes(align.toUpperCase())
      ? align.toUpperCase()
      : "LEFT"
    : "LEFT";

  return (
    <>
      <Box sx={chat__container}>
        <Box sx={avatar__container}>
          {align === "LEFT" && showAvatarImage === true ? (
            <LazyLoadImage
              src={avatarImageUrl ? avatarImageUrl : "/assets/icons/avatar.svg"}
              alt="avatar"
              style={avatar__img}
            ></LazyLoadImage>
          ) : (
            ""
          )}
        </Box>
        <Box sx={chat__video__wrapper}>
          <Box sx={chat__video__container}>
            <Box
              sx={{
                ...chat__video__bubble,
                background: align === "LEFT" ? "#EFF1F9" : "#FFF1F9",
                borderRadius:
                  align === "LEFT" ? "0px 8px 8px 8px" : "8px 0px 8px 8px",
              }}
            >
              <Box sx={chat__video__img__box}>
                {sending ? (
                  <LazyLoadImage
                    src={"/assets/rolling.svg"}
                    style={img}
                    alt="attachment"
                  ></LazyLoadImage>
                ) : (
                  <Box onClick={onClick} sx={img__container}>
                    <video style={img} autoPlay={false}>
                      <source
                        src={media?.s3_url ?? ""}
                        type="video/mp4"
                      ></source>
                    </video>
                    <LazyLoadImage
                      style={play__icon}
                      src="/assets/chat/play.png"
                    ></LazyLoadImage>
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  ...chat__video__footer__container,
                  pl: align === "LEFT" ? 0.5 : 0,
                }}
              >
                <Typography sx={chat__video__footer__time}>
                  {sending ? (failed ? "gagal mengirim" : "mengirim...") : time}
                </Typography>
                {sending ? (
                  <></>
                ) : align === "RIGHT" ? (
                  <LazyLoadImage
                    style={{
                      width: "12px",
                      height: "12px",
                    }}
                    src={
                      isRead
                        ? "/assets/chat/double-check-blue.png"
                        : "/assets/chat/double-check.png"
                    }
                  ></LazyLoadImage>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={avatar__container}>
          {align === "RIGHT" && showAvatarImage === true ? (
            <LazyLoadImage
              src={avatarImageUrl ? avatarImageUrl : "/assets/icons/avatar.svg"}
              alt="avatar"
              style={avatar__img}
            ></LazyLoadImage>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
}
